// client/src/components/admin/advertiser/AdvertiserInfoSummary.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function AdvertiserInfoSummary() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCount();
  }, []);

  const fetchCount = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/advertiser/info/count`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.ok) {
        setCount(data.count || 0);
      }
    } catch (error) {
      console.error('fetchCount error:', error);
    }
    setLoading(false);
  };

  return (
    <div className="advertiser-info-summary">
      <h3 className="advertiser-info-summary__title">광고주 정보 관리</h3>
      
      {loading ? (
        <div className="advertiser-info-summary__loading">
          불러오는 중...
        </div>
      ) : (
        <div className="advertiser-info-summary__content">
          총 <strong className="advertiser-info-summary__count">{count.toLocaleString()}</strong>명의 광고주가 등록되어 있습니다.
        </div>
      )}
    </div>
  );
}

export default AdvertiserInfoSummary;

